import { Component, input, OnInit, output, signal } from '@angular/core';
import { SessionTypeEnum } from '../../../shared/models/session-guide.model';

@Component({
  standalone: false,
  selector: 'app-session-type-step',
  templateUrl: './session-type-step.component.html',
  styleUrls: ['./session-type-step.component.scss'],
})
export class SessionTypeStepComponent implements OnInit {
  selectedSessionType = input<SessionTypeEnum>(SessionTypeEnum.WITH_SERVICE_TYPE);

  serviceClick = output<SessionTypeEnum>();

  expandedSessionType = signal<SessionTypeEnum | null>(null);

  sessions = [
    {
      id: SessionTypeEnum.WITH_SERVICE_TYPE,
      title: 'SMPP Integration With Routing Parameters',
      recommended: true,
      previewText:
        'What it is: Use one SMPP session to TelQ and connect multiple suppliers by adding service_type value per supplier. Service type is a routing parameter',
      content: {
        description:
          'which lets your SMS platform know which supplier to route the message to. It lets one session handle many suppliers. You can also use UDH or TLV as routing parameter.',
        whyChoose: 'Fewer sessions to maintain, faster to set up, easy to scale. Routing stays on your side for simpler control.',
        conditions: ['Your platform can route by service_type.', 'You want the simplest setup with one session and multiple suppliers.'],
        howItWorks: '1 SMPP connection ↔ TelQ → you pass a unique service_type per supplier → your SMS platform routes tests to the right supplier.',
        imageSrc: '/img/smpp_integration_service_type_mini.png',
        imageAlt: 'Service type integration',
      },
    },
    {
      id: SessionTypeEnum.WITHOUT_SERVICE_TYPE,
      title: 'SMPP Integration Without Routing Parameters',
      recommended: false,
      previewText: 'What it is: Create a separate SMPP session and test account for each supplier.',
      content: {
        description: '',
        whyChoose: '',
        conditions: ['Your platform cannot route by service_type.', 'You prefer isolating each supplier per sessions (more setup to maintain).'],
        howItWorks: 'Supplier A → Session A, Supplier B → Session B, etc. One session per supplier.',
        imageSrc: '/img/smpp_integration_without_service_type_mini.png',
        imageAlt: 'Service without type integration',
      },
    },
  ];

  isExpanded(itemId: SessionTypeEnum): boolean {
    return this.expandedSessionType() === itemId;
  }

  ngOnInit(): void {
    this.expandedSessionType.set(this.selectedSessionType());
  }

  onSessionTypeClick(type: SessionTypeEnum) {
    if (type === this.expandedSessionType()) {
      this.expandedSessionType.set(null);
    } else {
      this.expandedSessionType.set(type);
    }

    this.serviceClick.emit(type);
  }
}
